import { render, staticRenderFns } from "./permissionHom.vue?vue&type=template&id=3cdd4b5d&scoped=true"
import script from "./permissionHom.vue?vue&type=script&lang=js"
export * from "./permissionHom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdd4b5d",
  null
  
)

export default component.exports